module.exports = __webpack_public_path__ + "static/media/Scyther_gaussian2.32d7c804.png";